<ng-container [ngSwitch]="role$ | async">
  <app-psoa-dot-loader *ngSwitchCase="Roles.PREFIX_PSOA" [page]="page" [size]="size"></app-psoa-dot-loader>
  <app-afl-dot-loader *ngSwitchCase="Roles.PREFIX_AFL" [page]="page" [size]="size"></app-afl-dot-loader>
  <app-workshop-dot-loader *ngSwitchCase="Roles.PREFIX_WORKSHOP" [page]="page" [size]="size"></app-workshop-dot-loader>
  <app-afl-dot-loader *ngSwitchDefault></app-afl-dot-loader>
</ng-container>
